import { render, staticRenderFns } from "./TitleConsideration.vue?vue&type=template&id=712166d9&scoped=true&lang=pug&"
import script from "./TitleConsideration.vue?vue&type=script&lang=js&"
export * from "./TitleConsideration.vue?vue&type=script&lang=js&"
import style0 from "./TitleConsideration.vue?vue&type=style&index=0&id=712166d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712166d9",
  null
  
)

export default component.exports